import i18n from 'i18next'
import { ValidatorForm } from 'react-material-ui-form-validator'

export const ORG_TYPES = ["indoor_org", "combo_org", "summer_org", "sauna_org", "family_org", "shower_org"]

/**
 * parse url parameters
 * @returns {Object}
 */
export function getURLParameters() {
    var params = {};
    if (window.location.search) {
        var parts = window.location.search.substring(1).split('&');

        for (var i = 0; i < parts.length; i++) {
            var nv = parts[i].split('=');
            if (!nv[0]) continue;
            params[nv[0]] = nv[1] || true;
        }
    }
    return params
}

/**
 * get formatted currency string
 * @param {Number} price
 * @returns {String} 
 */
export function currencyFormat(price) {
    let convertPrice = `€ ${(parseFloat(price))},`.replace('.', ',')
    convertPrice = convertPrice.split(',').length > 2 ? convertPrice.slice(convertPrice, -1) : convertPrice
    return convertPrice
}

/**
 * add default validation rules to the ValidatorForm
 * @returns {undefined}
 */
export function addValidationRules() {
    const isPriceRegex = /(?=.*?\d)^\$?(([1-9]\d{0,2}(,\d{3})*)|\d+)?(\.\d{1,2})?$/
    ValidatorForm.addValidationRule('isPrice', (value) => {
        if (value && !isPriceRegex.test(value)) {
            return false;
        }
        return true;
    })
    ValidatorForm.addValidationRule('isEmptySelectField', (value) => {
        if (value === undefined || value === null || value === '') return false
        return true
    })
}

/**
 * get org type options
 * @returns {Object<key, title>}
 */
export const getOrgTypeOptions = () => {
    return ORG_TYPES.map(type => ({ key: type, title: i18n.t(type) }))
}

/**
 * get org type plural options
 * @returns {Object<key, title>}
 */
export const getOrgTypePluralOptions = () => {
    return ORG_TYPES.map(type => ({ key: type, title: i18n.t(`${type}_plural`) }))
}

/**
 * fetch org category price from given org and category
 * @param {Object} org 
 * @param {Object} cat 
 * @returns {Number}
 */
export const getOrgCategoryPrice = (org, cat) => {
    const orgCategory = org.categories.find(_cat => _cat.categoryId === cat._id)
    if (orgCategory && orgCategory.price !== null) {
        return orgCategory.price
    }
    return cat.price
}

/**
 * pad number
 * @param {Number} number 
 * @param {Number} digits 
 * @returns {String}
 */
export const padDigits = (number, digits) => {
    return Array(Math.max(digits - String(number).length + 1, 0)).join(0) + number
}

/**
 * split block range to numbers
 * @param {Array} blockNumbers
 * @param {String} orgCustomId special id of organization
 * @param {String} catCustomId special id of category
 * @return {Array}
 */
export const handleBlockNumbers = (blockNumbers, orgCustomId, catCustomId) => {
    const numbersSplit = blockNumbers.split(',')
    const numbers = {}
    numbersSplit.find(number => {
        if (number.includes('-')) {
            const pieces = number.split('-')
            const start = Number(pieces[0])
            const end = Number(pieces[1])
            for (let current = start; current <= end; current++) {
                numbers[current] = {
                    "status": [{ active: 1 }],
                    "notes": []
                }
            }
        } else {
            numbers[number] = {
                "status": [{ active: 1 }],
                "notes": []
            }
        }
    })
    return numbers
}

/**
 * encode box reference id
 * @param {Number} orgId organization id
 * @param {Number} catId category id
 * @param {Number} blockId block id
 * @param {Number} blockNumber block number
 * @param {Boolean} space split between numbers with space | default false
 * @returns {String} box reference id
 */
export const encodeBoxRefId = (orgId, catId, blockId, blockNumber, space = false) => {
    if (space) return `00${padDigits(orgId, 2)} ${padDigits(catId, 2)} ${padDigits(blockId, 2)} ${padDigits(blockNumber, 4)}`
    return `00${padDigits(orgId, 2)}${padDigits(catId, 2)}${padDigits(blockId, 2)}${padDigits(blockNumber, 4)}`
}


/**
 * decode box reference id 
 * @param {Number} boxRefId must be 12 character
 * @returns {Object <orgId, catId, blockId, blockNumber>}
 */
export const decodeBoxRefId = (boxRefId) => {
    const numberToStr = boxRefId.toString()
    const splitNumbers = numberToStr.replace(/(\d{2})/g, ' $1').trim().split(' ')
    return { orgId: padDigits(splitNumbers[1], 2), catId: padDigits(splitNumbers[2], 2), blockId: padDigits(splitNumbers[3], 2), blockNumber: `${splitNumbers[4]}${splitNumbers[5]}` }
}

/**
 * Check user permission
 * @param {Object} user 
 * @param {String} permission 
 * @returns {Boolean}
 */
export const hasUserPermission = (user, permission) => {
    return user && (user.isSuperAdmin || user.permissions.indexOf(permission) >= 0)
}